// extracted by mini-css-extract-plugin
export default {"cls1":"RAfBGwV01pTjvrDuSbjf","cls2":"LNM27FjMSUr3Ml2R_14A RAfBGwV01pTjvrDuSbjf","isTabletDown":"zV4zDcGX62bbadpVJm2K","isPhone":"bqcAxI78sMjDf1I0oqJz"};